export const CommonActionsReducer = (state = { isAccessDenied: false, selectedMenu: ''}, action) => {
  if (action.type === 'ACCESS_DENIED') {
    return {
      ...state,
      isAccessDenied: true,
    };
  } if (action.type === 'USER_MENU') {
    return {
      ...state,
      selectedMenu: action.payload
    }
  } else {
    return state;
  }
};
